import classNames from 'classnames'
import { ElDivider, ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { RouterLink } from 'vue-router'
import { firstCharToUpper } from 'utils'
import { useProjectTheme, useResponsive, useUserInfoStore } from 'store'
import { PLATFORM_CONFIG, PlatformKey } from 'platform-config'
import { ChangeLanguageCurrency } from 'crypto-otc/components/ChangeLanguageCurrency'
import { PageRoutes as CommonPageRoutes, getUserCenterPageRoute, UserCenterRoutes } from 'crypto-otc/constants/PageRoutes'
import { CopyText } from 'crypto-otc/components/Copy'
import { PageRoutes } from 'cloud-computing-power/constants/PageRoutes'
import { SecurityDialog } from './SecurityDialog'
import { HeaderCompLayout } from 'crypto-otc/components/HeaderComp.layout.tsx'
import { HocElDivider, HocElPopover, UserIcon, CustomButton, BgeUserIcon, Uid, UserVipIcon, HocElDialog, useDialog, DialogHeader, MenuIcon } from 'ui-components'
import { HeaderAppDownload } from 'crypto-otc/components/HeaderAppDownload'
import { useContents } from 'cloud-computing-power/config'
import useUserCommon from 'crypto-otc/hooks/use-user-common'
import UserMenuComp from 'crypto-otc/components/UserMenuComp'
import { HomeMobileMenu } from './HomeMobileMenu'
import MobileUserMenu from 'crypto-otc/components/MobileUserMenu'

type TabItem = {
  title: string
  isNeedLogin?: boolean
  path: string
  icon?: string
  subTitle?: string
  children?: TabItem[]
}

export const HeaderCompHashSpace = defineComponent({
  setup() {
    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const userInfoStore = useUserInfoStore()
    const UserIconComp = PlatformKey === 'bge' ? BgeUserIcon : UserIcon
    let autoCloseUserPopover: NodeJS.Timeout | null = null
    const { avatar, username, onLogout, vipLevel } = useUserCommon()
    const responsive = useResponsive()
    const themeStore = useProjectTheme()
    const theme = computed(() => themeStore.theme)

    const { dialogVisible, openDialog, closeDialog } = useDialog()

    const { dialogVisible: userDialogVisible, openDialog: openUserDialog, closeDialog: closeUserDialog } = useDialog()
    const tabs: TabItem[] = [
      {
        title: t('首页'),
        path: PageRoutes.Home,
      },
      {
        title: t('云算力'),
        path: PageRoutes.Cloud,
      },
      {
        title: t('订单'),
        path: PageRoutes.Order,
        isNeedLogin: true,
      },
      {
        title: t('算力收益'),
        path: PageRoutes.Income,
        isNeedLogin: true,
      },
      {
        title: t('计算器'),
        path: PageRoutes.Calculator,
      },
    ]

    const isUserPopover = ref(false)

    const rightTabs: TabItem[] = [
      // {
      //   title: '资产',
      //   path: getAssetsPageRoute(UserCenterRoutes.AssetFund),
      // },
    ]

    const onLogin = () => {
      router.push(CommonPageRoutes.Login)
    }

    const onRegister = () => {
      if (userInfoStore.isLogin) {
        router.push(PageRoutes.Cloud)
      } else {
        router.push(CommonPageRoutes.Register)
      }
    }

    const { buttonRadius } = useContents()

    const clearAutoCloseUserPopover = () => {
      if (autoCloseUserPopover) {
        clearTimeout(autoCloseUserPopover)
        autoCloseUserPopover = null
      }
    }

    onMounted(() => {
      document.body.addEventListener('click', () => {
        isUserPopover.value = false
        clearAutoCloseUserPopover()
      })
    })

    const onAutoCloseUserPopover = () => {
      autoCloseUserPopover = setTimeout(() => {
        isUserPopover.value = false
      }, 3000)
    }

    const onRecharge = () => {
      router.push(getUserCenterPageRoute(UserCenterRoutes.Recharge))
    }

    return () => (
      <HeaderCompLayout>
        <div class="header-nav-container">
          <RouterLink class="logo-box" to="/">
            <img width={130} src={PLATFORM_CONFIG.logo} alt="logo" />
          </RouterLink>
          {!responsive.isMobile && (
            <nav class="top-nav">
              {tabs.map((tab) => {
                if (tab.isNeedLogin && !userInfoStore.isLogin) return null
                if (tab.path === route.path) {
                  return (
                    <a href="javascript:void(0)" class="active">
                      {t(tab.title)}
                    </a>
                  )
                }
                return (
                  <RouterLink to={tab.path} class={classNames({ active: tab.path === route.path })}>
                    {t(tab.title)}
                  </RouterLink>
                )
              })}
            </nav>
          )}
          {!responsive.isMobile && (
            <nav class={'top-nav right'}>
              {userInfoStore.isLogin &&
                rightTabs.map((tab) => (
                  <RouterLink to={tab.path} class={classNames({ active: tab.path === route.path })}>
                    {firstCharToUpper(t(tab.title))}
                  </RouterLink>
                ))}
              {userInfoStore.isLogin && (
                <HocElPopover visible={isUserPopover.value} width={'auto'} hideAfter={0} teleported={false} placement={'bottom-end'} trigger={'click'} showArrow={false} offset={0}>
                  {{
                    reference: () => (
                      <div
                        class="user-icon"
                        onClick={(e) => {
                          e.stopPropagation()
                          isUserPopover.value = !isUserPopover.value
                          clearAutoCloseUserPopover()
                          onAutoCloseUserPopover()
                        }}
                      >
                        <UserIconComp />
                      </div>
                    ),
                    default: () => (
                      <div class="user-menu-container" onClick={(e) => e.stopPropagation()} onMousemove={clearAutoCloseUserPopover} onMouseout={onAutoCloseUserPopover}>
                        <div class="user-info">
                          <div class="avatar">
                            <img src={avatar.value} alt="avatar" />
                          </div>
                          <div class="user-name">
                            <p class="user-name-text">{username.value}</p>
                            <p class="user-id">
                              <span>UID:</span>
                              <Uid />
                              <CopyText value={userInfoStore.userInfo?.userInfo?.btUserId || userInfoStore.userInfo?.userInfo?.userId} />
                            </p>
                            {vipLevel.value?.isGreaterThan(0) && (
                              <div class="vip-info">
                                <UserVipIcon /> VIP{vipLevel.value}
                              </div>
                            )}
                          </div>
                        </div>
                        <div class="menu-list">
                          <UserMenuComp
                            onClose={() => {
                              isUserPopover.value = false
                            }}
                          />
                        </div>
                        <HocElDivider direction="horizontal"></HocElDivider>
                        {/* 退出登录 */}
                        <div class="bottom-logout-item">
                          <div class="logout-btn" onClick={onLogout}>
                            {t('退出登录')}
                          </div>
                        </div>
                      </div>
                    ),
                  }}
                </HocElPopover>
              )}

              {!userInfoStore.isLogin && (
                <>
                  <div onClick={onLogin} class={'login-register-btn'}>
                    {t('登录')}
                  </div>
                  <CustomButton type="primary" class={'login-register-btn register'} radius={buttonRadius.value} onClick={onRegister}>
                    {t('注册')}
                  </CustomButton>
                </>
              )}
              {PlatformKey !== 'bge' ? <ElDivider direction="vertical" /> : null}
              <ElSpace size={PlatformKey === 'bge' ? 40 : 36}>
                <HeaderAppDownload />
                <ChangeLanguageCurrency isShowIcon={PlatformKey !== 'bge'} />
              </ElSpace>
            </nav>
          )}
          {responsive.isMobile && (
            <ElSpace size={12} style={{ marginLeft: 'auto' }}>
              {userInfoStore.isLogin && (
                <>
                  <CustomButton radius={6} class="recharge-btn" type="primary" onClick={onRecharge}>
                    {t('充值')}
                  </CustomButton>
                  <span onClick={openUserDialog}>
                    <div class="user-icon">
                      <UserIconComp />
                    </div>
                  </span>
                </>
              )}
              <span class="menu-icon" onClick={openDialog}>
                <MenuIcon fill={theme.value.header.activeColor} />
              </span>
            </ElSpace>
          )}
          <SecurityDialog />

          <HocElDialog
            v-model={userDialogVisible.value}
            placement="right"
            closeOnClickModal={false}
            modal={false}
            offsetTop={0}
            showClose={false}
            onClose={closeUserDialog}
            appendToBody
          >
            {{
              header: () => (
                <DialogHeader onClose={closeUserDialog} height={64} style={{ backgroundColor: theme.value.header.background }} closeIconFill={theme.value.header.activeColor}>
                  <img width={130} src={theme.value.logo} alt="logo" onClick={() => router.push(PageRoutes.Home)} />
                </DialogHeader>
              ),
              default: () => <MobileUserMenu onClose={closeUserDialog} />,
            }}
          </HocElDialog>

          <HocElDialog v-model={dialogVisible.value} modal={false} placement="right" closeOnClickModal={false} offsetTop={0} showClose={false} onClose={closeDialog} appendToBody>
            {{
              header: () => (
                <DialogHeader onClose={closeDialog} height={64} style={{ backgroundColor: theme.value.header.background }} closeIconFill={theme.value.header.activeColor}>
                  <img width={130} src={PLATFORM_CONFIG.logo} alt="logo" onClick={() => router.push(PageRoutes.Home)} />
                </DialogHeader>
              ),
              default: () => <HomeMobileMenu onClose={closeDialog} />,
            }}
          </HocElDialog>
        </div>
      </HeaderCompLayout>
    )
  },
})
